import { useTemplateSetting } from "./hooks/useCompanySettings";
import MainContent from "./components/MainContent";
import MultipleTicker from "./components/MultipleTicker";
import Footer from "./components/Footer";
import { useEffect, useLayoutEffect } from "react";
import DownloadButton from "./components/DownloadButton";
import { useStore } from "react-redux";
import appConfig from "./utils/app-config";

const isRealtimeEnabled = () => {
  const { realTimeId } = appConfig.get();
  var isEnabledRTForTicker = realTimeId.length > 0;
  return isEnabledRTForTicker;
};  

function App() {
  const template = useTemplateSetting();
  const templateSection = `${template.toLocaleLowerCase()}-section`;
  const store = useStore();

  useLayoutEffect(() => {
    const templateClassName = `template-${template?.toLocaleLowerCase()}`;
    document.body.classList.add(templateClassName);
    return () => {
      document.body.classList.remove(templateClassName);
    };
  }, [template]);

  useEffect(() => {
    const loadRealTime = async () => {
      const realtimeInit = (await import('./real-time/init-realtime')).default;
      realtimeInit(store)
    }

    if(isRealtimeEnabled()) {
      loadRealTime();
    }
  }, []);

  return (
    <>
    <main className={window.appSettings?.isRtl ? "arabic-format" : "main-app"} dir={window.appSettings?.isRtl ? "rtl" : "ltr"}>
      <section className={templateSection}>
        <MultipleTicker />
        <MainContent />
        <DownloadButton />

      </section>
    </main>
    <Footer />
    </>
  );
}

export default App;
